import React, { useContext, useState } from "react";
import axios from "axios";


import PrimaryButton from "../../Components/Buttons/PrimaryButton";
import FormInput from "../../Components/FormInput/FormInput";

import gif from './pic.jpg'

import { authContext } from "../../store/AuthContext";

const Login = () => {
    const authCtx = useContext(authContext);

    const serverURL = process.env.REACT_APP_SERVER_URL;
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('')


    const emailChangeHandler = (event) => {
        setEmail(event.target.value);
    }

    const passwordChangeHandler = (event) => {
        setPassword(event.target.value);
    }

    const submitHandler = async (event) => {
        event.preventDefault();

        try {
            const res = await axios({
                method: 'POST',
                url: `${serverURL}/api/auth/login`,
                headers: {
                    "Access-Control-Allow-Origin": "*"
                },
                data: {
                    email,
                    password
                }
            })
            if (res && res.status === 200) {
                authCtx.login(res.data.token, res.data.adminType);
            } else {
                document.getElementsByClassName('login-error-wrong-credentials')[0].style.display = 'block'

                setTimeout(() => {
                    document.getElementsByClassName('login-error-wrong-credentials')[0].style.display = 'none'
                }, 2000)
            }

        } catch (error) {
            if (error.response && error.response.status === 401) {
                document.getElementsByClassName('login-error-wrong-credentials')[0].style.display = 'block'

                setTimeout(() => {
                    document.getElementsByClassName('login-error-wrong-credentials')[0].style.display = 'none'
                }, 2000)
            } else {
                document.getElementsByClassName('login-error-something-went-wrong')[0].style.display = 'block'

                setTimeout(() => {
                    document.getElementsByClassName('login-error-something-went-wrong')[0].style.display = 'none'
                }, 2500)
            }
        }

    }

    return (
        <div className="fullscreen-wrapper flex" >
            <div className="row login" >
                <div className="col-lg-6 left-box" >
                    <img className="login-gif" src={gif} alt="NK Realtors" />
                </div>
                <div className="col-lg-6 right-box" >
                    <img className="nk-logo" src="/nk-logo.png" alt="nk-logo" />
                    <h1 className="login-heading" >Hello Again!</h1>
                    <p className="login-desc" >Kindly enter your credentials to login</p>
                    <p className="login-desc login-error-wrong-credentials" style={{ color: 'red', display: 'none' }} >Wrong credentials</p>
                    <p className="login-desc login-error-something-went-wrong" style={{ color: 'red', display: 'none' }} >Something went wrong</p>
                    <form className="login-form" onSubmit={submitHandler} >
                        <FormInput onChange={emailChangeHandler} value={email} autoComplete='off' id='email' type='email' label='Email' />
                        <FormInput onChange={passwordChangeHandler} value={password} autocomplete='off' id='password' type='password' label='Password' />
                        <PrimaryButton style={{ textTransform: 'uppercase', height: '45px' }} type='submit' >Login</PrimaryButton>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Login;